import { useCreateLocationBroadcastState } from '@kinetic-ui/broadcast';
import { LocationForm, LocationTypes, useAnyPrivilege } from '@kinetic-ui/shared';
import { useCreateLocationActionRouteParams } from './useCreateLocationActionRouteParams';
import { KineticModule, PrivilegeType } from '@kinetic-ui/data-layer';
import { useCallback, useMemo } from 'react';
import { useCreateLocationForm } from './useCreateLocationForm';
import { getActionRoute } from '~/router/getActionRoute';
import { CREATE_LOCATION_ACTION_ROUTE } from '~/router/constants';

export const CreateLocation = () => {
  const { defaultLocationType } = useCreateLocationActionRouteParams();
  const [, setValue] = useCreateLocationBroadcastState();

  const initialData = useMemo(() => {
    return {
      name: '',
      locationType: defaultLocationType ?? LocationTypes.Intersection,
    };
  }, [defaultLocationType]);
  const hasPrivilege = useAnyPrivilege([PrivilegeType.Create], KineticModule.Locations);

  const onSaveComplete = useCallback(
    ({ id }: { id: string }) => {
      setValue({ id });
    },
    [setValue]
  );
  const useForm = useCreateLocationForm(onSaveComplete);

  return (
    <LocationForm
      initialData={initialData}
      hasPrivilege={hasPrivilege}
      tabPath={`${getActionRoute(CREATE_LOCATION_ACTION_ROUTE)}/`}
      locationParams={{}}
      useForm={useForm}
      showWorkflowButton={false}
      showBackButton={false}
    />
  );
};
